const menu = {
    label: '• Política de Preços',
    to: '/sol/politicaprecos',
    rules: ['SOL-001'],
};

export default menu;
